module.exports = __webpack_public_path__ + "media/images/icons/edit-9edb6cd42f8a1cf5a1c33eab1857e5c9.svg";